import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-index_refresh",
  "use": "icon-index_refresh-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-index_refresh\"><g fill=\"#FF8109\" fill-rule=\"evenodd\"><path d=\"M20.985 24.413a1.555 1.555 0 0 1 .153-2.194c4.537-3.944 5.017-10.819 1.073-15.355C18.267 2.327 11.392 1.847 6.856 5.79 2.319 9.734 1.838 16.61 5.782 21.146a1.555 1.555 0 0 1-2.348 2.04 13.995 13.995 0 1 1 19.745 1.38 1.555 1.555 0 0 1-2.194-.153z\" /><path d=\"m17.464 27.473 8.266.028-8.266-8.627z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol